export default __webpack_public_path__ + "static/media/home-event.c36dcb4d.jpg";